import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function fetchFilterElementReducer(state = initialState.filterElements, action) {
  switch (action.type) {
    case types.GET_MULTI_SELECT_VALUE: {
      return Object.assign({}, state, {
        filterElements: action.filterElements,
      });
    }
    default:
      return state;
  }
}
